import translateFieldsHelper from '../helpers/translateFieldsHelper';
import removeExtraSubFieldsHelper from '../helpers/removeExtraSubFieldsHelper';

const transform = role => translateFieldsHelper(role, ['screens'], 'displayName');

const reverseTransform = season => removeExtraSubFieldsHelper(season, ['screens']);

export { transform, reverseTransform };
